import { useQuery, useMutation, useQueryClient } from 'react-query';
import { GetCoworkingSpaces, GetCoworkingSpaceById, AddNewCoworkingSpace, UpdateCoworkingSpace, DeleteCoworkingSpace } from '../services/backend';
import { Notify, NotifyError } from '../utils/functions';

export function useGetCoworkingSpaces() {
    return useQuery('coworkingSpaces', () => GetCoworkingSpaces('all'), {
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
        select: (data) => {
            return data?.data?.coworkingSpaces || [];
        },
        onError: (error) => {
            NotifyError("Failed to fetch coworking spaces", error);
            console.error("Error fetching coworking spaces:", error);
        }
    });
}
export function useGetCoworkingSpaceById(coworkingSpaceId) {
    return useQuery(
        ['coworkingSpace', coworkingSpaceId],
        () => GetCoworkingSpaceById(coworkingSpaceId),
        {
            enabled: !!coworkingSpaceId,
            staleTime: 5 * 60 * 1000, // 5 minutes
            onError: (error) => {
                NotifyError("Failed to fetch coworking space details", error);
                console.error("Error fetching coworking space details:", error);
            }
        }
    );
}

export function useAddCoworkingSpace() {
    const queryClient = useQueryClient();
    return useMutation(({ floorId, data }) => AddNewCoworkingSpace(floorId, data), {
        onSuccess: () => {
            Notify("Coworking space added successfully");

            queryClient.invalidateQueries('coworkingSpaces');
        },
        onError: (error) => {
            NotifyError("Failed to add coworking space", error);
            console.error("Error adding coworking space:", error);
        }
    });
}

export function useUpdateCoworkingSpace() {
    const queryClient = useQueryClient();
    return useMutation(({ coworkingSpaceId, data }) => UpdateCoworkingSpace(coworkingSpaceId, data), {
        onSuccess: () => {
            Notify("Coworking space updated successfully");

            queryClient.invalidateQueries('coworkingSpaces');
        },
        onError: (error) => {
            NotifyError("Failed to update coworking space", error);
            console.error("Error updating coworking space:", error);
        }
    });
}

export function useDeleteCoworkingSpace() {
    const queryClient = useQueryClient();
    return useMutation(({ coworkingSpaceId }) => DeleteCoworkingSpace(coworkingSpaceId), {
        onSuccess: () => {
            Notify("Coworking space deleted successfully");

            queryClient.invalidateQueries('coworkingSpaces');
        },
        onError: (error) => {
            NotifyError("Failed to delete coworking space", error);
            console.error("Error deleting coworking space:", error);
        }
    });
}   